// removed by extract-text-webpack-plugin
module.exports = {"frame-top":"src-components-common-frame----Frame-module---frame-top---11079","frame-bottom":"src-components-common-frame----Frame-module---frame-bottom---2QFFp","frame-left":"src-components-common-frame----Frame-module---frame-left---3reYf","frame-right":"src-components-common-frame----Frame-module---frame-right---2kkYc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/frame/Frame.module.scss
// module id = 103
// module chunks = 79611799117203 207321357075633